export enum PaymentModule {
    Patient = 1,
    Appointment,
    Pharmacy,
    Labs,
    ScanAppointment,
    Admission,
    ViewMachine,
    Services,
    MachineWiseScanAppointment,
}